const LiveGamesIcon: React.FC = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.8299 20.6901L6.6499 22.0001H2.1499V14.3101H3.7799V20.6901H6.8299Z" fill="#E8E8E8" />
        <path d="M7.81006 22.0001V14.3101H9.46006V22.0001H7.81006Z" fill="#E8E8E8" />
        <path
            d="M12.4599 22.0001L10.1699 14.3101H11.9199L13.4899 20.6501L14.9999 14.3101H16.6699L14.4599 22.0001H12.4699H12.4599Z"
            fill="#E8E8E8"
        />
        <path
            d="M19.0201 15.5001V17.5001H21.4401V18.6801H19.0201V20.8001H22.0001V22.0001H17.3901V14.3101H21.9801L21.8001 15.5001H19.0201Z"
            fill="#E8E8E8"
        />
        <path
            d="M8.6298 1C7.5498 1 6.5198 1.18 5.5498 1.49L6.1698 3.39C6.9498 3.14 7.7798 3 8.6398 3C13.0498 3 16.6398 6.59 16.6398 11H18.6398C18.6298 5.48 14.1498 1 8.6298 1Z"
            fill="#DA5457"
        />
        <path
            d="M8.62979 5C7.97979 5 7.35979 5.1 6.77979 5.29L7.39979 7.21C7.78979 7.08 8.19978 7 8.62979 7C10.8398 7 12.6298 8.79 12.6298 11H14.6298C14.6298 7.69 11.9398 5 8.62979 5Z"
            fill="#DA5457"
        />
        <path
            d="M8.62988 13C9.73445 13 10.6299 12.1046 10.6299 11C10.6299 9.89543 9.73445 9 8.62988 9C7.52531 9 6.62988 9.89543 6.62988 11C6.62988 12.1046 7.52531 13 8.62988 13Z"
            fill="#DA5457"
        />
        <path
            d="M14.7598 5.87012C15.9298 7.26012 16.6298 9.05012 16.6298 11.0001H17.5598C17.2998 8.95012 16.2698 7.14012 14.7598 5.87012Z"
            fill="#B23A38"
        />
        <path
            d="M9.6298 2C12.1398 2 14.4198 2.93 16.1798 4.45C14.3498 2.34 11.6498 1 8.6298 1C7.5498 1 6.5198 1.18 5.5498 1.49L6.1698 3.39C6.3698 3.32 6.5898 3.29 6.7998 3.24L6.5598 2.49C7.5298 2.18 8.5698 2 9.6398 2H9.6298Z"
            fill="#DA5457"
        />
        <path
            d="M11.9097 8.72021C12.3597 9.37021 12.6297 10.1502 12.6297 11.0002H13.4897C13.2497 10.0602 12.6797 9.26021 11.9097 8.72021Z"
            fill="#B23A38"
        />
        <path
            d="M9.62979 6C11.0298 6 12.3198 6.48 13.3398 7.29C12.2398 5.9 10.5398 5 8.62979 5C7.97979 5 7.35979 5.1 6.77979 5.29L7.39979 7.21C7.59979 7.14 7.80979 7.09 8.01979 7.05L7.76978 6.29C8.34978 6.1 8.96978 6 9.61978 6H9.62979Z"
            fill="#DA5457"
        />
        <path
            d="M9.62988 10C9.91988 10 10.1999 10.07 10.4499 10.18C10.1399 9.49 9.43988 9 8.62988 9C7.52988 9 6.62988 9.9 6.62988 11C6.62988 11.81 7.11988 12.51 7.80988 12.82C7.69988 12.57 7.62988 12.29 7.62988 12C7.62988 10.9 8.52988 10 9.62988 10Z"
            fill="#DA5457"
        />
        <path
            d="M16.1798 4.45C14.4198 2.93 12.1398 2 9.6298 2C8.5498 2 7.5198 2.18 6.5498 2.49L6.7898 3.24C7.3798 3.1 7.9898 3 8.6298 3C11.0898 3 13.2898 4.12 14.7598 5.87C16.2698 7.14 17.2998 8.95 17.5598 11H18.6298C18.6298 8.49 17.6998 6.21 16.1798 4.45Z"
            fill="#B23A38"
        />
        <path
            d="M13.3398 7.29C12.3198 6.48 11.0298 6 9.62979 6C8.97979 6 8.35979 6.1 7.77979 6.29L8.02978 7.05C8.22978 7.02 8.42979 6.99 8.62979 6.99C9.98979 6.99 11.1898 7.67 11.9098 8.71C12.6798 9.25 13.2498 10.05 13.4898 10.99H14.6298C14.6298 9.59 14.1498 8.3 13.3398 7.28V7.29Z"
            fill="#B23A38"
        />
        <path
            d="M10.6299 11C10.6299 10.71 10.5599 10.43 10.4499 10.18C10.1999 10.07 9.91988 10 9.62988 10C8.52988 10 7.62988 10.9 7.62988 12C7.62988 12.29 7.69988 12.57 7.80988 12.82C8.05988 12.93 8.33988 13 8.62988 13C9.72988 13 10.6299 12.1 10.6299 11Z"
            fill="#B23A38"
        />
    </svg>
)

LiveGamesIcon.displayName = 'LiveGamesIcon'

export default LiveGamesIcon
